import { LoadingOverlay } from "@mantine/core";

interface ModalLoadingOverlayProps {
  isLoading?: boolean;
}

export const ModalLoadingOverlay = ({ isLoading }: ModalLoadingOverlayProps) => {
  return <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />;
};
